import Image from "next/image"

const CompanyValuesMobile = () => {
    return (
        <>
            <div className="h-72 bg-[#FAA224] py-4">
                <div className="grid h-full grid-cols-2">
                    <div className="mx-4 flex h-full flex-col items-center justify-center gap-4">
                        <p className="font-bold leading-10 text-white lg:text-7xl">
                            رؤيتنـــا
                        </p>
                        <p className="text-center font-normal text-white lg:text-5xl">
                            رؤيـتنا تتـعـدى جبـالنا وتـغوص في أعـمـاق بـحارنا
                            وتـداعـب غـيـوم سـمـاءنا. نـهدف إلى تـوفير منصة سهلة
                            استخدام وسلسة التفاعل تعزز التجربة الترفيهية.
                        </p>
                    </div>
                    <div className="flex h-full items-center justify-center">
                        <div className="flex h-2/4 w-2/4 items-center justify-center">
                            <Image
                                src="https://cdn.pass-tickets.com/frontend/Frame%201000003592.png"
                                alt="celebration"
                                width={300}
                                height={300}
                                layout="responsive"
                                className="rounded bg-cover bg-center shadow-2xl lg:h-full"
                                quality="100"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-72 bg-[#10B89F] py-4">
                <div className="grid h-full grid-cols-2">
                    <div className="mx-4 flex h-full flex-col items-center justify-center gap-4">
                        <p className="font-bold leading-10 text-white lg:text-7xl">
                            قيمنـــا
                        </p>
                        <p className="text-center font-normal text-white lg:text-5xl">
                            قيمنـا هـي الـبهجـة، و الـمرح والشغف، والتنوع،
                            والابتكار، والثقة.
                        </p>
                    </div>
                    <div className="flex h-full items-center justify-center">
                        <div className="flex h-2/4 w-2/4 items-center justify-center">
                            <Image
                                src="https://cdn.pass-tickets.com/frontend/Frame%201000003593.png"
                                alt="celebration"
                                width={300}
                                height={300}
                                layout="responsive"
                                className="rounded bg-cover bg-center shadow-2xl lg:h-full"
                                quality="100"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-72 bg-gradient-to-b from-[#221852] to-[#18113B] py-4">
                <div className="grid h-full grid-cols-2">
                    <div className="mx-4 flex h-full flex-col items-center justify-center gap-4">
                        <p className="font-bold leading-10 text-white lg:text-7xl">
                            مهمتنـــا
                        </p>
                        <p className="text-center font-normal text-white lg:text-5xl">
                            وعندنا مهمه اسمى وهي صنع السعادة، ونحقق ذلك من خلال
                            توفير خيارات ترفيهية مـتنوعة تنـاسب الـكبار والـصغار
                            وتـساهم في رفـع جـودة الـحياة.
                        </p>
                    </div>
                    <div className="flex h-full items-center justify-center">
                        <div className="flex h-2/4 w-2/4 items-center justify-center">
                            <Image
                                src="https://cdn.pass-tickets.com/frontend/Frame%201000003592%20(1).png"
                                alt="celebration"
                                width={300}
                                height={300}
                                layout="responsive"
                                className="rounded bg-cover bg-center shadow-2xl shadow-gray-600 lg:h-full"
                                quality="100"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-72 bg-[#ED1A5A] py-4">
                <div className="grid h-full grid-cols-2">
                    <div className="mx-4 flex h-full flex-col items-center justify-center gap-4">
                        <p className="font-bold leading-10 text-white lg:text-7xl">
                            غايتنـــــا
                        </p>
                        <p className="text-center font-normal text-white lg:text-5xl">
                            غايتنـا هـي صنع تجارب ترفيهية لا حصر لها من حيث
                            النوع والعدد، وإعادة تعريف الترفيه في مملكتنا، وخلق
                            عالـم مذهل من البهجة و السعادة من خـلال منصة رقمية
                            متكاملة.
                        </p>
                    </div>
                    <div className="flex h-full items-center justify-center">
                        <div className="flex h-2/4 w-2/4 items-center justify-center">
                            <Image
                                src="https://cdn.pass-tickets.com/frontend/Frame%201000003595.png"
                                alt="celebration"
                                width={300}
                                height={300}
                                layout="responsive"
                                className="rounded bg-cover bg-center shadow-2xl shadow-gray-600 lg:h-full"
                                quality="100"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompanyValuesMobile
